import { render, staticRenderFns } from "./bar.vue?vue&type=template&id=baa5ebaa&scoped=true&lang=html&"
import script from "./bar.vue?vue&type=script&lang=js&"
export * from "./bar.vue?vue&type=script&lang=js&"
import style0 from "./bar.vue?vue&type=style&index=0&id=baa5ebaa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa5ebaa",
  null
  
)

component.options.__file = "bar.vue"
export default component.exports